<ng-container *ngIf="dataIn.isSingle; else multiple">
  <form *ngIf="!(isCreating$ | async)" [formGroup]="moveTrackForm" novalidate>
    <rk-modal-wrapper
      (submitted)="onSubmit()"
      (cancelled)="onCancel()"
      (closed)="onAbort()"
      [title]="'MEDIA.MODAL.TRACK.MOVE.TITLE_SINGLE' | translate"
      [submitText]="'MEDIA.MODAL.TRACK.MOVE.ACTION_BUTTON' | translate"
      [loading]="isLoading$ | async"
      [hideCancelOnLoading]="true"
    >
      <div
        class="content-move-track"
        [innerHTML]="
          'MEDIA.MODAL.TRACK.MOVE.CONTENT_SINGLE'
            | translate: { name: getEllipsisTitle() }
        "
      ></div>
      <div class="bac-container">
        <rk-dropdown-autocomplete
          [modal]="true"
          formControlName="targetBac"
          [data]="bacs$ | async"
        ></rk-dropdown-autocomplete>
      </div>
    </rk-modal-wrapper>
  </form>
</ng-container>

<ng-template #multiple>
  <form *ngIf="!(isCreating$ | async)" [formGroup]="moveTrackForm" novalidate>
    <rk-modal-wrapper
      (submitted)="onSubmit()"
      (cancelled)="onCancel()"
      (closed)="onAbort()"
      [title]="'MEDIA.MODAL.TRACK.MOVE.TITLE_MULTIPLE' | translate"
      [submitText]="'MEDIA.MODAL.TRACK.MOVE.ACTION_BUTTON' | translate"
      [loading]="isLoading$ | async"
      [hideCancelOnLoading]="true"
    >
      <div
        class="content-move-track"
        [innerHTML]="
          'MEDIA.MODAL.TRACK.MOVE.CONTENT_MULTIPLE'
            | translate: { tracks: dataIn.trackIdList.length }
        "
      ></div>
      <div class="bac-container">
        <rk-dropdown-autocomplete
          [modal]="true"
          formControlName="targetBac"
          [data]="bacs$ | async"
        ></rk-dropdown-autocomplete>
      </div>
    </rk-modal-wrapper>
  </form>
</ng-template>
